module.exports = __webpack_public_path__ + "img/ícone-lixeira.8d4417f2.svg";